export function formatWincToAr(winc: bigint | number | string): string {
  const wincBigInt = BigInt(winc);
  const arDenominator = BigInt('1000000000000');

  const integerPart = wincBigInt / arDenominator;
  const fractionalPart = wincBigInt % arDenominator;

  if (fractionalPart === 0n) {
    return integerPart.toString();
  }

  const fractionalString = fractionalPart
    .toString()
    .padStart(12, '0')
    .replace(/0+$/, '');

  return `${integerPart}.${fractionalString}`;
}
